// @LTG-ID: F-091
// @STATUS: BUILT
// @HERMETIC: true
// @DOCS: 08_FEATURES.md#F-091, source `Journals/what-is-my-business-worth.html`
//        lines 918-962 (Figure 01 — three approaches triptych).
// @CHANGED: 2026-02 session_004 (CHG-0059)
// @OWNER: web
//
// F-081 — Brief-page infographic: "The three approaches at a glance."
// Verbatim port of source Figure 01. Self-contained inline SVG; uses brand
// colors directly (navy / teal / gold) per source — no CSS variable use inside
// SVG because Safari's color-mix support for `fill` was inconsistent at the
// time of the original authoring.

export const ThreeApproachesTriptych = () => {
    return (
        <div
            className="ltg-brief-infographic"
            data-testid="brief01-figure-01"
        >
            <span className="ltg-brief-infographic-label">
                Figure 01 &middot; The three approaches at a glance
            </span>
            <h4>How credentialed appraisers triangulate to a number.</h4>
            <div className="ltg-brief-three-approaches">
                <div className="ltg-brief-approach-card">
                    <svg
                        width="56"
                        height="56"
                        viewBox="0 0 56 56"
                        fill="none"
                        aria-hidden="true"
                    >
                        <rect x="6" y="36" width="6" height="14" fill="#0A2A5E" />
                        <rect x="16" y="28" width="6" height="22" fill="#0A2A5E" />
                        <rect x="26" y="18" width="6" height="32" fill="#B08D3E" />
                        <rect x="36" y="10" width="6" height="40" fill="#0A2A5E" />
                        <rect x="46" y="20" width="6" height="30" fill="#0A2A5E" />
                        <path
                            d="M3 8 L9 14 L19 6 L29 16 L39 4 L49 12"
                            stroke="#18B0BD"
                            strokeWidth="1.5"
                            fill="none"
                        />
                    </svg>
                    <h5>Income approach</h5>
                    <p>
                        Present value of expected future cash flows. DCF or
                        capitalization of earnings.
                    </p>
                </div>
                <div className="ltg-brief-approach-card">
                    <svg
                        width="56"
                        height="56"
                        viewBox="0 0 56 56"
                        fill="none"
                        aria-hidden="true"
                    >
                        <circle
                            cx="14"
                            cy="28"
                            r="9"
                            fill="none"
                            stroke="#0A2A5E"
                            strokeWidth="2"
                        />
                        <circle
                            cx="42"
                            cy="28"
                            r="9"
                            fill="none"
                            stroke="#0A2A5E"
                            strokeWidth="2"
                        />
                        <circle
                            cx="28"
                            cy="14"
                            r="9"
                            fill="none"
                            stroke="#B08D3E"
                            strokeWidth="2.5"
                        />
                        <circle
                            cx="28"
                            cy="42"
                            r="9"
                            fill="none"
                            stroke="#0A2A5E"
                            strokeWidth="2"
                        />
                    </svg>
                    <h5>Market approach</h5>
                    <p>
                        Compare to actual transactions in similar private
                        companies. The primary lens at sale.
                    </p>
                </div>
                <div className="ltg-brief-approach-card">
                    <svg
                        width="56"
                        height="56"
                        viewBox="0 0 56 56"
                        fill="none"
                        aria-hidden="true"
                    >
                        <rect
                            x="8"
                            y="8"
                            width="40"
                            height="40"
                            fill="none"
                            stroke="#0A2A5E"
                            strokeWidth="2"
                        />
                        <line
                            x1="8"
                            y1="20"
                            x2="48"
                            y2="20"
                            stroke="#0A2A5E"
                            strokeWidth="1.5"
                        />
                        <line
                            x1="8"
                            y1="32"
                            x2="48"
                            y2="32"
                            stroke="#0A2A5E"
                            strokeWidth="1.5"
                        />
                        <line
                            x1="8"
                            y1="44"
                            x2="48"
                            y2="44"
                            stroke="#0A2A5E"
                            strokeWidth="1.5"
                        />
                        <line
                            x1="20"
                            y1="8"
                            x2="20"
                            y2="48"
                            stroke="#0A2A5E"
                            strokeWidth="1.5"
                        />
                        <line
                            x1="36"
                            y1="8"
                            x2="36"
                            y2="48"
                            stroke="#0A2A5E"
                            strokeWidth="1.5"
                        />
                        <rect
                            x="20"
                            y="20"
                            width="16"
                            height="12"
                            fill="#B08D3E"
                            opacity="0.4"
                        />
                    </svg>
                    <h5>Asset approach</h5>
                    <p>
                        Adjusted net asset value. Drives value for asset-heavy
                        and holding companies; rare for operating businesses.
                    </p>
                </div>
            </div>
            <p className="ltg-brief-infographic-caption">
                The three approaches each answer a different question; a
                defensible valuation answers all three and reconciles the
                weights.
                <cite>
                    Source: AICPA SSVS No. 1; Pepperdine Private Capital Markets
                    Report 2025 (33% guideline-transactions weighting)
                </cite>
            </p>
        </div>
    );
};

export default ThreeApproachesTriptych;
